import moment from 'moment-jalaali'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { VisaItemType } from 'src/types'
import { AdminData } from './components/AdminData'
import { VisaStatus } from 'src/components/VisaStatus/VisaStatus'
import { on } from 'events'
import { CrewsList } from './components/CrewsList'
import { AgentData } from './components/AgentData'
import { useTranslation } from 'react-i18next'

export const MobileRow = ({ onSuccessMutate, ...record }: VisaItemType & { onSuccessMutate: Function  ,  nationality: Array<{ id: string, en_name: string, fa_name: string }> }) => {

  const { id, created_at, visa: { fa_name }, command_letter_number, automation_number, letter_number, status , agent} = record


  const [selectedCrews, setSelectedCrews] = useState<{ persons: string[] }>({ persons: [] })


  const user = useSelector((state) => (state as any).user.user)

  const isAgent = user?.role_key === "agent"

  const isAdmin = user?.role_key === "super_admin"

  const { t } = useTranslation();





  return (
    <div className='flex flex-col gap-4 p-3 bg-gray-100 border border-gray-200 rounded-xl relative text-sm'>

      <div className=' flex flex-col gap-3.5'>

        <div className='absolute left-0 top-2 px-2 bg-green-100 font-bold border border-green-400 rounded-lg rounded-l-none'>
          <VisaStatus status={status} />
        </div>

        <span className='text-sm text-gray-700'>
         {t('RequestNumber')}:  {id}
        </span>

        <span className='font-bold'>{fa_name}</span>

        <span className='text-sm'>{t('RequestDate')} :  {moment(created_at).format('jYYYY/jMM/jDD')}</span>
        <span className='text-sm'>{t('agent')} :  {agent?.name ?? '-'} {agent?.last_name ?? '-'}</span>

        {isAdmin && <AdminData record={record} onSuccessMutate={onSuccessMutate} />}

        {isAgent && <AgentData record={record} onSuccessMutate={onSuccessMutate} selectedCrews={selectedCrews.persons} />} 


        <CrewsList
          record={record}
          selectedCrews={selectedCrews.persons}
          onSelectCrews={(items) => setSelectedCrews({ persons: items })}
        />




      </div>

    </div>
  )
}
